import styled from 'styled-components'
import { BaseInput, BaseMaskedInput } from 'components/Inputs/Base'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 30px;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const FormField = styled(Container)`
  flex: ${props => props.stretch ? props.stretch : 1};
  justify-content: flex-end;
  align-items: center;
  padding: 0px;
  margin: 0px;
`

export const Row = styled(Container)`
  width: 100%;
  padding: 0px;
  gap: 10px;
  margin-bottom: 15px;
  flex-direction: row;
  align-items: flex-end;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 16px;
  text-align: center;
`

export const Title = styled(InfoText)`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
`

export const SubTitle = styled(Title)`
  font-size: 16px;
`

export const Label = styled.label`
  text-align: center;
  color: #000000;
  margin-bottom: 4px;

  &:hover {
    cursor: pointer;
  }
`

export const MoneyText = styled(SubTitle)`
  color: #44CF6C;
`

export const MoneyTextMask = styled.p`
  color: #44CF6C;
  font-size: 18px;
  font-weight: bold;
  margin-top: 9px;
  margin-bottom: 0px;
  padding: 0px;
`

export const WarningText = styled.p`
  margin: 0px;
  text-align: center;
  font-size: 14px;
  font-weight: 200;
  color: #FF3939;
`

export const ErrorContainer = styled.div`
  padding: 8px;
  margin-bottom: 20px;
  width: 100%;
  border-radius: 15px;
  text-align: center;
  background-color: #FF3939;

  p {
    color: #FFFFFF;
    margin: 0px;
  }
`

export const Input = styled(BaseInput)`
  width: 100%;
  margin: 0px 5px;
`

export const MaskedInput = styled(BaseMaskedInput)`
  width: 100%;
  margin: 0px 5px;
`
